import Livesearch from "adeliom-livesearch-js";
import {mergeObjects} from "dauphine-js";

export const init = (livesearchConfig = {}) => {

    const form = document.querySelector('[js-livesearch-form]');

    if (!form) {
        return null;
    }

    const defaultConfig = {
        pathAjax: form.getAttribute('js-action'),
        actionAjax: form.getAttribute('js-ajax'),
        perPage: 9,
        paramsInUrl: true,
        animationScrollTo: "smooth",
        minimumTimeLoading: 500
    };

    const config = mergeObjects(defaultConfig, livesearchConfig);

    const livesearch = new Livesearch(config);

    livesearch.init();

    return livesearch;
};

export const afterChange = (livesearch, callback = null) => {
    if (livesearch) {
        livesearch.on('afterChange', (response) => {
            if (callback) {
                callback(response);
            }
        });
    }
};

export const beforeChange = (livesearch, callback = null) => {
    if (livesearch) {
        livesearch.on('beforeChange', (response) => {
            if (callback) {
                callback(response);
            }
        });
    }
};

export const isLoading = (livesearch, callback = null) => {
    if (livesearch) {
        livesearch.on('isLoading', (response) => {
            if (callback) {
                callback(response);
            }
        });
    }
};
